import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { Stepper } from 'eymp-uicomps';
import intl from 'react-intl-universal';
import LabelValue from 'eymp-uicomps/components/LabelValue';

function ProgressStatusPres({ milestones }) {
  const [caseMaileStone, setCaseMileStone] = useState([]);
  useEffect(() => {
    let data = [];
    if (milestones) {
      for (let i = 0; i < milestones.length; i++) {
        data.push(
          <Stepper
            className={milestones[i].fieldData ? 'display-progress' : 'hide-progress'}
            stepLabels={[
              <div>
                <LabelValue value={milestones[i].fieldLabel} />
                <LabelValue className={milestones[i].fieldData ? '' : 'd-none'} value={milestones[i].fieldData} />
              </div>,
            ]}
            activeStep={milestones[i].fieldData ? '1' : ''}
          />,
        );
      }
      setCaseMileStone(data);
    }
  }, []);
  return (
    <Grid item sm={12}>
      <Grid className="header-wrap">
        <LabelValue value="progress" />
      </Grid>
      <Grid className="progress-status-wrapper" container>
        {milestones && milestones.length > 0 ? (
          <div style={{ padding: '10px 15px' }}>{caseMaileStone}</div>
        ) : (
          <Grid className="progress-block">
            <p>{intl.get('newDashboard.common.noItemtoDisplay')}</p>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}

export default ProgressStatusPres;
